import React, { useEffect, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import Navbar from './components/navbar/navbar-2';
import HomePage from './HomePage';
import Mobile from './Mobile';
import Laptop from './Laptop';
import Fridge from './Fridge';
import Acunit from './Acunit';
import TV from './Tv';
import WashingMachine from './WashingMachine';
import ProductDetailsTV from './ProductDetailsTV';
import ProductDetailsAC from './ProductDetailsAC';
import ProductDetailsFridge from './ProductDetailsFridge';
import ProductDetailsWash from './ProductDetailsWash';
import ProductDetailsLaptop from './ProductDetailsLaptop';
import ProductDetailsTablet from './ProductDetailsTablet';
import ProductDetailsMobile from './ProductDetailsMobile';
import TwoCompare from './components/TwoCompare';
import CompareFeature from './components/CompareFeature';
import NewArrival from './newArrival/NewArrival';
import Tablet from './Tablet';

export function truncate(str, n) {
  return str?.length > n ? str.substr(0, n - 1) + '...' : str;
}

function App() {
  const [width, setWidth] = useState(window.innerWidth);
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  let secondProductScreen = window.sessionStorage.getItem('secondProductScreen');

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
    console.log('isMobile = ' + isMobile);
  }, [width]);

  let isMobile = width <= 768;
  console.log('isMobile = ' + isMobile);

  return (
    <div className='App'>
      <Switch>
        <Route exact path='/'>
          <HomePage />
        </Route>
        <Route exact path='/PHONE'>
          <Navbar />
          <Mobile />
        </Route>
        <Route exact path='/TABLET'>
          <Navbar />
          <Tablet />
        </Route>
        <Route exact path='/TV'>
          <Navbar />
          <TV />
        </Route>
        <Route exact path='/LAPTOP'>
          <Navbar />
          <Laptop />
        </Route>
        <Route exact path='/AC'>
          <Navbar />
          <Acunit />
        </Route>
        <Route exact path='/REFRIGERATOR'>
          <Navbar />
          <Fridge />
        </Route>
        <Route exact path='/WASHING'>
          <Navbar />
          <WashingMachine />
        </Route>
        <Route exact path='/compare'>
          <Navbar />
          {/* <TwoCompare /> */}
          {isMobile ? <CompareFeature /> : <TwoCompare />}
        </Route>
        <Route path='/REFRIGERATOR/product'>
          <Navbar />
          <ProductDetailsFridge />
        </Route>
        <Route path='/WASHING/product'>
          <Navbar />
          <ProductDetailsWash />
        </Route>
        <Route path='/TV/product'>
          <Navbar />
          <ProductDetailsTV />
        </Route>
        <Route path='/AC/product'>
          <Navbar />
          <ProductDetailsAC />
        </Route>
        <Route path='/LAPTOP/product'>
          <Navbar />
          <ProductDetailsLaptop />
        </Route>
        <Route path='/TABLET/product'>
          <Navbar />
          <ProductDetailsTablet />
        </Route>
        <Route path='/PHONE/product'>
          <Navbar />

          {/* {alert(typeof secondProductScreen)} */}
          {secondProductScreen == 1 ? <TwoCompare /> : <ProductDetailsMobile />}
        </Route>
        <Route path='/compare/compare-features'>
          <Navbar />
          <CompareFeature />
        </Route>
        <Route path='/new-arrival-product'>
          <Navbar />
          <NewArrival />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
